class Slideshow {
	constructor($dom, index) {
		this.dom = $dom;
		this.target = $dom.querySelector("ul.c-list");
		this.list = $dom.querySelectorAll("ul.c-list li");
		this.index = index;
		this.count = 0;
		this.max = this.list.length;
		this.navWrap = $dom.querySelector(".c-nav_slide");
		this.dotNav = this.navWrap.querySelector("ul");
		this.dots = [];
		this.scrollTimer = null;
		this.isPC = false;
		this.pcBreakpoint = 1072;

		this.makeDotNav();
		this.bindEvents();
		this.checkDevice();
	}

	makeDotNav() {
		let HTML = "";
		for (let i = 0; i < this.max; i++) {
			let cls = i === 0 ? "active" : "";
			HTML += `<li><button class="${cls}" data-index="${i}">${i}</button></li>`;
		}
		this.dotNav.innerHTML = HTML;
		this.dots = this.dotNav.querySelectorAll("button");
	}

	checkDevice() {
		this.isPC = window.innerWidth >= this.pcBreakpoint;
		this.checkNavVisibility();
	}

	checkNavVisibility() {
		const needsScroll = this.target.scrollWidth > this.target.clientWidth + 1;
		this.navWrap.style.display = needsScroll ? "" : "none";
	}

	bindEvents() {
		// ドットクリック
		this.dots.forEach((dot) => {
			dot.addEventListener("click", () => {
				const idx = parseInt(dot.dataset.index, 10);
				this.goTo(idx);
			});
		});

		// スクロール → アクティブドット更新
		this.target.addEventListener("scroll", () => {
			clearTimeout(this.scrollTimer);
			this.scrollTimer = setTimeout(() => {
				this.updateActiveDot();
			}, 80);
		});

		// PC: ホバー中に縦スクロール → 横スクロール変換
		this.dom.addEventListener("wheel", (e) => {
			if (!this.isPC) return;

			const el = this.target;
			const maxScrollLeft = el.scrollWidth - el.clientWidth;

			// 横スクロールの余地がなければ通常スクロールに任せる
			if (maxScrollLeft <= 0) return;

			// 左端で上スクロール or 右端で下スクロール → 通常スクロール
			if (el.scrollLeft <= 0 && e.deltaY < 0) return;
			if (el.scrollLeft >= maxScrollLeft - 1 && e.deltaY > 0) return;

			e.preventDefault();
			el.scrollLeft += e.deltaY;
		}, { passive: false });

		// リサイズ
		window.addEventListener("resize", () => {
			this.checkDevice();
		});
	}

	goTo(idx) {
		if (idx < 0 || idx >= this.max) return;
		this.count = idx;
		this.list[idx].scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
		this.setActiveDot(idx);
	}

	updateActiveDot() {
		const containerRect = this.target.getBoundingClientRect();
		const containerCenter = containerRect.left + containerRect.width / 2;
		let closestIdx = 0;
		let closestDist = Infinity;

		this.list.forEach((li, i) => {
			const rect = li.getBoundingClientRect();
			const liCenter = rect.left + rect.width / 2;
			const dist = Math.abs(liCenter - containerCenter);
			if (dist < closestDist) {
				closestDist = dist;
				closestIdx = i;
			}
		});

		this.count = closestIdx;
		this.setActiveDot(closestIdx);
	}

	setActiveDot(idx) {
		this.dots.forEach((dot, i) => {
			dot.classList.toggle("active", i === idx);
		});
	}
}

export let slideshows = {
	arry: [],
	init: function () {
		let $slides = document.querySelectorAll(".js-slideshow");
		if ($slides) {
			$slides.forEach(($slide, index) => {
				slideshows.arry[index] = new Slideshow($slide, index);
			});
		}
	},
};